import ReactDOM from "react-dom";
import "reflect-metadata";
import App from "./app/App";
import domReadyPromise from "./legacy/utils/domReadyPromise";

declare global {
  interface Window {
    __redirectInitPromise?: Promise<void>;
  }
}

const reactAppTarget = document.getElementById("root");
const redirectInitReady = window.__redirectInitPromise || Promise.resolve();

redirectInitReady
  .then(domReadyPromise)
  .then(function onDomReady() {
    ReactDOM.render(<App />, reactAppTarget);
  })
  .catch(function whenQASmiling(error) {
    console.error("APP  ERROR:", error);
    window.location.href = "/unexpected-error.html";
  });
